<script>
  import clsx from "clsx";
  let className;
  export { className as class };
  export let src;
  export let name;
  export let description;
  export let moderator = false;
  export let moderatorSalutatory = null;
  export let small = false;
</script>

<figure class={clsx(className, small ? "max-w-[140px] basis-[140px]" : "max-w-[150px] basis-[150px]", "mb-4  shrink-0 ")}>
  <img {src} alt={name} class="max-w-full" />
  <figcaption class="mt-0.5 text-xxs">
    <strong class="block text-xs">
      {#if moderator}
        {#if moderatorSalutatory == 2}
          Moderatorin
        {:else}
          Moderator
        {/if}
      {/if}
      {name}
    </strong>
    {description}
  </figcaption>
</figure>
